import { removeEmptyValuesInObject } from '@core/helpers'

const formatPrice = (price) => (price ? parseFloat(price, 2).toFixed(2) : price)

export const productModel = ({
  brand,
  category,
  chillpackDuration,
  color = '',
  dealType,
  id,
  insurancePrice,
  insuranceTitle,
  isSwapEnabled,
  list,
  listingId,
  merchantId,
  model,
  name,
  position = 1,
  price,
  provider,
  // number of products selected by the user (funnel)
  quantity,
  // available stock of products
  stock,
  shipper,
  shippingDelay,
  shippingOptions = [],
  shippingPrice,
  source,
  splitPayment,
  trustpackDuration,
  uuid,
  variant,
  warrantyDuration,
}) => {
  return removeEmptyValuesInObject({
    product_id: uuid || (id && String(id)),
    product_legacy_id: id && String(id),
    product_list: list,
    product_position: position,
    product_brand: brand,
    product_category: category,
    product_name: name,
    product_price: formatPrice(price),
    product_quantity: quantity && Number(quantity),
    product_variant: variant,
    product_color: color,
    product_trustpack_duration: trustpackDuration,
    product_shipping_delay: shippingDelay,
    product_seller_id: merchantId && String(merchantId),
    product_model: model,
    product_is_swap_eligible: isSwapEnabled,
    product_deal_type: dealType,
    product_shipper: shipper,
    product_display_type: source,
    product_listingID: listingId && String(listingId),
    product_chillpack_months: chillpackDuration,
    product_warranty_duration: warrantyDuration,
    product_shipping_price: formatPrice(shippingPrice),
    product_paymentmethod: splitPayment,
    product_displayvendor: provider,
    product_shipping_options: shippingOptions,
    product_units_in_stock: stock && Number(stock),
    product_insurance_title: insuranceTitle,
    product_insurance_price: insurancePrice,

    // Missing:
    // product_has_backlabel
    // product_backlabel_price
    // product_is_review_displayed
    // product_nb_reviews_displayed
  })
}
